"use client";

const SiteWrapper = ({ children }: { children: React.ReactNode }) => {
  return <main id="main-content">{children}</main>;
};

export default SiteWrapper;
